export type HomepageMotionEnvironment = {
  prefersReducedMotion: boolean;
  hasCoarsePointer: boolean;
  isNarrowViewport: boolean;
};

export function shouldUseHeavyHomepageMotion({
  prefersReducedMotion: _prefersReducedMotion,
  hasCoarsePointer: _hasCoarsePointer,
  isNarrowViewport: _isNarrowViewport,
}: HomepageMotionEnvironment): boolean {
  // Scroll-linked effects are the main source of dropped input frames on this
  // long page. Decorative motion is handled with CSS, while content stays
  // immediately available on every device.
  return false;
}

export function getHomepageMotionEnvironment(): HomepageMotionEnvironment {
  return {
    prefersReducedMotion: window.matchMedia("(prefers-reduced-motion: reduce)").matches,
    hasCoarsePointer: window.matchMedia("(pointer: coarse)").matches,
    isNarrowViewport: window.matchMedia("(max-width: 767px)").matches,
  };
}
